import { Box, Typography } from '@mui/material'
import React from 'react'
import { Section, Question } from '../../../models/questionnaire'
import HelpTip from '../startups/HelpTip'
import QuestionnaireQuestion from './QuestionnaireQuestion'

interface Props {
  section: Section
  onAnswerSelection: (question: Question, answer: number, comment: string | undefined) => void
}

const QuestionnaireSection = (props: Props) => {
  return (
    <Box sx={{
      backgroundColor: 'white',
      maxWidth: '1200px',
      padding: '24px',
      width: '100%',
      margin: '24px auto'
    }}>
      <Box display='flex' flexDirection='row' alignItems='center'>
        <Typography variant='h2' sx={{
          marginRight: '12px'
        }}>
          {props.section.name}
        </Typography>
        {props.section.displayDescription &&
          <HelpTip tip={props.section.displayDescription!} />
        }
      </Box>
      <Typography variant='h6'>
        {props.section.displayText}
      </Typography>
      {props.section.questions.map((question) => (
        <QuestionnaireQuestion onAnswerSelection={(answer: number, comment: string | undefined) => {
          props.onAnswerSelection(question, answer, comment)
        }} key={question.name} question={question} />
      ))}
    </Box>
  )
}

export default QuestionnaireSection
